import { Field, Input } from "@zendeskgarden/react-forms";
import type { InputSearchProps, ProductResult } from "./interfaces";
import { useUserSearch } from "./useInputSearch";

export function InputSearch(props: InputSearchProps) {
  const {
    query,
    results,
    open,
    loading,
    error,
    highlight,
    handleChange,
    handleKeyDown,
    handleBlur,
    handleSelect,
  } = useUserSearch({ ...props, mode: "product" }); // fiz para trazer o modo de produto

  return (
    <div className={props.className} style={{ position: "relative" }}>
      {props.label && <Field.Label>{props.label}</Field.Label>}

      <Input
        type="text"
        value={query}
        disabled={props.disabled}
        placeholder={props.placeholder ?? "Buscar produto (descrição ou código)"}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        aria-autocomplete="list"
        aria-expanded={open}
        aria-controls="search-listbox"
      />

      {open && (
        <div
          role="listbox"
          id="search-listbox"
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            right: 0,
            zIndex: 10,
            backgroundColor: "white",
            border: "1px solid #d1d5db",
            borderRadius: 8,
            maxHeight: 288,
            overflowY: "auto",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          }}
        >
          {loading && (
            <div
              style={{
                padding: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <div
                className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"
                style={{ borderTopColor: "transparent" }}
              ></div>
              <span style={{ fontSize: 14, color: "#6b7280" }}>Buscando produtos...</span>
            </div>
          )}
          {!loading && error && (
            <div style={{ padding: 10, fontSize: 14, color: "#dc2626" }}>{error}</div>
          )}
          {!loading && !error && results.length === 0 && (
            <div style={{ padding: 10, fontSize: 14 }}>Nenhum resultado</div>
          )}

          {!loading &&
            !error &&
            results
              .filter((item): item is ProductResult => item.kind === "product")
              .map((item, idx) => {
                const isActive = idx === highlight;
                const secondary = item.custom_object_fields?.codigo_do_produto ?? "—";

                return (
                  <div
                    key={`${item.kind}-${item.id}`}
                    role="option"
                    aria-selected={isActive}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      handleSelect(item);
                    }}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      borderBottom: "1px solid #f3f4f6",
                      backgroundColor: isActive ? "#e0e7ff" : "white",
                    }}
                  >
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{item.name}</div>
                    <div style={{ fontSize: 12, color: "#6b7280" }}>{secondary}</div>
                  </div>
                );
              })}
        </div>
      )}
    </div>
  );
}
